// removed by extract-text-webpack-plugin
module.exports = {"container":"_3LsPYnAjbpXG5wR05GIkKd"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7789fbf6","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/rep-call/toolbar/toolbar.less
// module id = 4j2B
// module chunks = 1